var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstruction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instruction",
    transform: "translate(-1045 -325)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 30,
    height: 30,
    transform: "translate(1045 325)",
    fill: "#13bcd4",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "document",
    transform: "translate(989.859 328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3189",
    "data-name": "Path 3189",
    d: "M78.475,4.981,73.955.705A2.568,2.568,0,0,0,72.183,0H63.578A2.581,2.581,0,0,0,61,2.578V21.422A2.581,2.581,0,0,0,63.578,24H76.7a2.581,2.581,0,0,0,2.578-2.578V6.854A2.589,2.589,0,0,0,78.475,4.981Zm-1.366.644h-3.5a.235.235,0,0,1-.234-.234v-3.3ZM76.7,22.594H63.578a1.173,1.173,0,0,1-1.172-1.172V2.578a1.173,1.173,0,0,1,1.172-1.172h8.391V5.391a1.642,1.642,0,0,0,1.641,1.641h4.266V21.422A1.173,1.173,0,0,1,76.7,22.594Z",
    fill: "#13bcd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3190",
    "data-name": "Path 3190",
    d: "M139.016,200H128.7a.7.7,0,0,0,0,1.406h10.313a.7.7,0,0,0,0-1.406Z",
    transform: "translate(-63.859 -190.625)",
    fill: "#13bcd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3191",
    "data-name": "Path 3191",
    d: "M139.016,280H128.7a.7.7,0,0,0,0,1.406h10.313a.7.7,0,0,0,0-1.406Z",
    transform: "translate(-63.859 -266.875)",
    fill: "#13bcd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3192",
    "data-name": "Path 3192",
    d: "M132.112,360H128.7a.7.7,0,0,0,0,1.406h3.409a.7.7,0,0,0,0-1.406Z",
    transform: "translate(-63.859 -343.125)",
    fill: "#13bcd4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstruction);
export default __webpack_public_path__ + "static/media/instruction.16d1dec9d3e0e60e738a36932866fab3.svg";
export { ForwardRef as ReactComponent };